export const TABLE_HEADERS = [
  "name",
  "serial",
  "location_name",
  "claimed_by",
  "alarm",
  "date_claimed",
];
